import { observable, makeObservable, action, runInAction } from 'mobx';
import { api } from '../../constants/apis';
import { get, put } from '../../utils/axios-requests';

export default class MembershipUiStore {
  @observable error: string = '';
  @observable context: any = null;
  @observable membership: string = '';

  constructor() {
    makeObservable(this);
  }

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public initliazeContext = (context: any) => {
    this.context = context;
  };

  @action 
  public updateMembership = async (membershipId: string) => {
    try {
      await put(api.users.membership, {
        membershipId
      });

      return true;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  }
  
  @action 
  public getMembership = async () => {
    try {
      const res = await get(api.users.membership);

      runInAction(()=> {
        this.membership = res.data.id.toString();
      });

      return true;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  }
  

}
